/**
 * Audio Recorder Worklet
 */

let micStream;

export async function startAudioRecorderWorklet(audioRecorderHandler) {
    // Create an AudioContext
    const audioRecorderContext = new AudioContext({ sampleRate: 16000 });
    // console.log("AudioContext sample rate:", audioRecorderContext.sampleRate);

    // Load the AudioWorklet module

    // DEV path: Vite/webpack dev server serves /public at /
    const DEV_WORKLET = "/worklets/pcm-recorder-processor.js";
    // PROD path: let post-build script rewrite /content/dam/hlb/my/chatbot/public/... to the site CDN path
    const PROD_WORKLET = "/content/dam/hlb/my/chatbot/public/worklets/pcm-recorder-processor.js";

    try {
        await audioRecorderContext.audioWorklet.addModule(DEV_WORKLET);
    } catch {
        // In built bundles, the runtime path gets rewritten by run-build-path.cjs
        await audioRecorderContext.audioWorklet.addModule(PROD_WORKLET);
    }

    // Request access to the microphone
    micStream = await navigator.mediaDevices.getUserMedia({
        audio: { channelCount: 1 },
    });
    const source = audioRecorderContext.createMediaStreamSource(micStream);

    // Create an AudioWorkletNode that uses the PCMProcessor
    const audioRecorderNode = new AudioWorkletNode(
        audioRecorderContext,
        "pcm-recorder-processor"
    );

    // Connect the microphone source to the worklet.
    source.connect(audioRecorderNode);
    audioRecorderNode.port.onmessage = (event) => {
        // Convert to 16-bit PCM
        const pcmData = convertFloat32ToPCM(event.data);

        // Send the PCM data to the handler.
        audioRecorderHandler(pcmData);
    };
    return [audioRecorderNode, audioRecorderContext, micStream];
}

/**
 * Stop the microphone.
 */
export function stopMicrophone(micStream) {
    micStream.getTracks().forEach((track) => track.stop());
    // console.log("stopMicrophone(): Microphone stopped.");
}

// Convert Float32 samples to 16-bit PCM.
function convertFloat32ToPCM(inputData) {
    // Create an Int16Array of the same length.
    const pcm16 = new Int16Array(inputData.length);
    for (let i = 0; i < inputData.length; i++) {
        // Multiply by 0x7fff (32767) to scale the float value to 16-bit PCM range.
        pcm16[i] = inputData[i] * 0x7fff;
    }
    // Return the underlying ArrayBuffer.
    return pcm16.buffer;
}
